module.exports = __webpack_public_path__ + "img/logo2laason2.86af35db.png";